<div class="grey-rectangle" [ngStyle]="applyDesign()">
  <div class="small-grey-rectangle">
    <span class="title">Últimos Registros</span>
  </div>
</div>
